<template>
  <div class="side-bar-wrap">
    <a
      v-for="(item, index) in navList"
      :key="item.ID"
      class="bar-item"
      @click="handleJump(item)"
    >
      <img
        v-if="moduleName == item.MODULE_ENNAME"
        :src="
          item.MODULE_ICON_HIGHLIGHT
            ? item.MODULE_ICON_HIGHLIGHT
            : getIco('navbtn')
        "
        class="ico"
        alt="nav-icon"
      />
      <img
        v-else
        :src="item.MODULE_ICON ? item.MODULE_ICON : getIco('navbtn')"
        class="ico"
        alt="nav-icon"
      />
      <p class="text" :class="{ active: moduleName == item.MODULE_ENNAME }">
        {{ item.MODULE_NAME_MULTILINGUAL }}
        <span class="line" v-if="index < navList.length - 1"></span>
      </p>
      <span class="line-hen" v-if="index < navList.length - 1"></span>
    </a>
  </div>
</template>

<script lang="ts" setup>
import { useRouter, useRoute } from 'vue-router';
import { sdkOpenLink } from '@utiles/sdkCtrl';
import { computed } from 'vue';
import { useBaseStore } from '@store/base';
import { getIco } from '@config/siteConfig';

const base = useBaseStore();
const navList = computed(() => {
  return base.navList;
});
const router = useRouter();
const route = useRoute();
const moduleName = computed(() => {
  return route.meta.moduleName;
});

const handleJump = (navItem) => {
  clickButtonPoint({
    btnName: `nav_${navItem.MODULE_ENNAME}`,
    moduleName: moduleName.value,
  });
  if (navItem?.REDIRECT_LINK) {
    sdkOpenLink({
      link: navItem.REDIRECT_LINK,
      openWay: navItem.REDIRECT_TYPE,
      loginDir: '1',
      appendParams: '1',
      source: pageSourceType.navigation,
    });
    return;
  }
  if (moduleName.value == navItem.MODULE_ENNAME) {
    return;
  }
  router.push({
    path: `${navItem.MODULE_PATH}`,
    query: {
      source: pageSourceType.navigation,
    },
  });
};
</script>
<style scoped lang="scss">
@import '@assets/scss/dimen.scss';
.side-bar-wrap {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-evenly;
  height: auto;
  max-height: 170px;
  background: $layercolor;
  width: 100%;
  @media (orientation: landscape) {
    max-height: unset;
    flex-direction: column;
    width: 170px;
    height: 100%;
    left: 0;
    top: 0;
    box-sizing: border-box;
    @supports (
        (padding-left: constant(safe-area-inset-left)) or
          (padding-left: env(safe-area-inset-left))
      )
      and (-webkit-overflow-scrolling: touch) {
      width: 210px;
      padding-left: constant(safe-area-inset-left);
      padding-left: env(safe-area-inset-left);
    }
  }
  @media only screen and (min-height: 640px) and (orientation: landscape) {
    width: calc(170px / $pcRate);
    padding-left: 0;
  }
  .bar-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 0;
    width: 100%;
    height: auto;
    cursor: pointer;

    &:active .ico {
      transform: scale(0.9);
    }

    .ico {
      height: 26px;
      margin-bottom: 13px;
      @media only screen and (min-height: 640px) and (orientation: landscape) {
        width: calc(26px / $pcRate);
      }
    }

    @media (orientation: landscape) {
      justify-content: center;
      padding: unset;
      height: 100%;
      .line-hen {
        position: absolute;
        width: 26px;
        height: 2px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background: #e4e4e4;
      }
    }
    @media only screen and (min-height: 640px) and (orientation: landscape) {
      .line-hen {
        width: calc(26px / $pcRate);
        height: calc(2px / $pcRate);
      }
    }
    .text {
      position: relative;
      text-align: center;
      width: 100%;
      color: $titlecolor;
      font-size: $fzNormal;
      overflow-wrap: break-word;

      @media only screen and (min-height: 640px) and (orientation: landscape) {
        font-size: $fzNormalPc;
      }
      &.active {
        color: $maincolor;
      }
      .line {
        display: none;
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 1px;
        background: #e4e4e4;
        @media (orientation: landscape) {
          display: none;
        }
      }
    }
  }
}
</style>
